import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { DashboardLayout } from '../components/layout/DashboardLayout';
import { 
  Certificate,
  Download,
  Eye,
  Spinner
} from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function Certificates() {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCertificates();
  }, []);

  const fetchCertificates = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/certificates`, {
        withCredentials: true
      });
      setCertificates(response.data);
    } catch (error) {
      console.error('Error fetching certificates:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex justify-center py-20">
          <Spinner size={48} className="animate-spin text-[#2C3E50]" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="max-w-5xl" data-testid="certificates-page">
        <h1 className="text-2xl sm:text-3xl font-bold text-[#1A252F] mb-2">Meus Certificados</h1>
        <p className="text-[#5C6B7A] mb-8">Suas conquistas e certificações</p>

        {certificates.length === 0 ? (
          <div className="bg-white rounded-xl border border-[#2C3E50]/10 p-12 text-center">
            <Certificate size={64} className="mx-auto text-[#BDC3C7] mb-4" />
            <h2 className="text-xl font-semibold text-[#1A252F] mb-2">Nenhum certificado ainda</h2>
            <p className="text-[#5C6B7A] mb-6">Complete cursos para ganhar seus certificados</p>
            <Link to="/courses">
              <button className="bg-[#2C3E50] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#1A252F] transition-colors">
                Ver Cursos
              </button>
            </Link>
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-6">
            {certificates.map((cert) => (
              <div 
                key={cert.id}
                className="bg-white rounded-xl border border-[#2C3E50]/10 p-6 hover:shadow-lg transition-shadow"
                data-testid={`certificate-${cert.id}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-16 h-16 rounded-lg bg-[#27AE60]/10 flex items-center justify-center flex-shrink-0">
                    <Certificate size={32} className="text-[#27AE60]" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-[#1A252F] mb-1">{cert.course_title}</h3>
                    <p className="text-sm text-[#5C6B7A] mb-3">
                      Emitido em: {new Date(cert.issued_at).toLocaleDateString('pt-BR')}
                    </p>
                    <div className="flex gap-2">
                      <Link to={`/certificates/${cert.id}`}>
                        <button className="flex items-center gap-1 px-3 py-2 text-sm bg-[#2C3E50] text-white rounded-lg hover:bg-[#1A252F] transition-colors">
                          <Eye size={16} />
                          Visualizar
                        </button>
                      </Link>
                      <Link to={`/certificates/${cert.id}`}>
                        <button className="flex items-center gap-1 px-3 py-2 text-sm border border-[#BDC3C7] text-[#2C3E50] rounded-lg hover:bg-[#F0F2F5] transition-colors">
                          <Download size={16} />
                          Baixar
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}

export default Certificates;
